import { render, staticRenderFns } from "./BilibiliList.vue?vue&type=template&id=66ea673a&scoped=true&"
import script from "./BilibiliList.vue?vue&type=script&lang=js&"
export * from "./BilibiliList.vue?vue&type=script&lang=js&"
import style0 from "./BilibiliList.vue?vue&type=style&index=0&id=66ea673a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ea673a",
  null
  
)

export default component.exports